import { AfterViewInit,Component, Inject, Optional, OnInit,ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatChipInputEvent} from '@angular/material/chips';
import { MatTable } from '@angular/material/table';
//import {MatTableDataSource} from '@angular/material/table';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import {TranslateService} from '@ngx-translate/core';
import { EscenarioService } from 'app/main/services/escenario.service';
import { first } from 'rxjs/operators';
import {MatSnackBar} from '@angular/material/snack-bar';
import { DialogBoxPrintComponentEscenario } from './dialog-print-box.component';

//import { MatSort } from '@angular/material/sort';
import { Escenario } from 'app/main/models/escenario.model';
import { Probabilidad } from 'app/main/models/probabilidad.model';
import { Impacto } from 'app/main/models/impacto.model';
import { ResultadoEscenario } from 'app/main/models/resultado-escenario.model';

import {MatCalendar} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_FORMATS, MatDateFormats} from '@angular/material/core';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';

const Parser = require('expr-eval').Parser;

const ELEMENT_DATA: Probabilidad[] = [];
const ELEMENT_DATA_I: Impacto[] = [];
const ELEMENT_DATA_R: ResultadoEscenario[] = [];

@Component({
  selector: 'app-dialog-box',
  templateUrl: './dialog-box.component.html',
  styleUrls: ['./dialog-box.component.scss']
})
export class DialogBoxComponent {

  //Chart map-heat
  multi: any[];
  view: any[] = [500, 400];

  legend: boolean = true;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = true;
  showXAxisLabel: boolean = true;
  xAxisLabel: string = 'Probabilidad';
  yAxisLabel: string = 'Impacto';
  gradient: boolean = false;

  colorScheme = {
    domain: ['#34C229', '#F1F80C','#E44D25']
  };

  customColors = [];

  action: string;
  LOCAL_DATA: any;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  new_line_p:Probabilidad = {id:null,descripcion:'',nombre:'',valor:0,new:true};
  new_line_i:Impacto = {id:null,descripcion:'',nombre:'',valor:0,new:true};

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  tiposEvaluacion = [];

  displayedColumns: string[] = ['nombre','valor','descripcion','action'];
  displayedColumnsResults: string[] = ['probabilidad','impacto','resultado','action'];
  dataSource = ELEMENT_DATA;
  dataSourceI = ELEMENT_DATA_I;
  dataSourceR = ELEMENT_DATA_R;//new MatTableDataSource(ELEMENT_DATA_R);

  @ViewChild('tableProbabilidad', {static: true}) tableProbabilidad: MatTable<any>;
  @ViewChild('tableImpacto', {static: true}) tableImpacto: MatTable<any>;
  @ViewChild('tableResultados', {static: true}) tableResultados: MatTable<any>;
  //@ViewChild(MatSort) sort: MatSort;

  /*
  ngAfterViewInit() {
    this.dataSourceR.sort = this.sort;
  }*/


  constructor(
    public dialogRef: MatDialogRef<DialogBoxComponent>,
    public translate: TranslateService,
    public dialog: MatDialog,
    private service: EscenarioService,
    private _snackBar: MatSnackBar,

    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.LOCAL_DATA = {...data};
    this.dataSource = data.probabilidades || [];
    this.dataSourceI = data.impactos || [];
    this.dataSourceR = data.resultados || [];//new MatTableDataSource(data.resultados || []);
    this.action = this.LOCAL_DATA.action;
    this.calcularResultados();

    this.dataSourceI.sort((a, b) => (a.valor < b.valor) ? 1 : -1);
    this.dataSourceI = [...this.dataSourceI];
    this.dataSource.sort((a, b) => (a.valor < b.valor) ? 1 : -1);
    this.dataSource = [...this.dataSource];

    //Object.assign(this, { multi });
  }

  print():void{

    const dialogRef = this.dialog.open(DialogBoxPrintComponentEscenario, {
      width: '100%',
      data: {action:"Print", obj:this.LOCAL_DATA},
      autoFocus: false,
      disableClose: true
    });

  }

  doAction(): void{
    console.log('im here');
    this.LOCAL_DATA.probabilidades = this.dataSource;
    this.LOCAL_DATA.impactos = this.dataSourceI;

    //Si se quiere agregar, hay que validar que no exista uno con el mismo nombre.

    if(this.action==="Add" || this.action==="Update" || this.action==="Duplicate"){
      
      if(this.action==="Duplicate")
        this.LOCAL_DATA.id = undefined;

      this.service.exist(this.LOCAL_DATA).pipe(first()).subscribe(
        data => {
            if(!data.body)
              this.dialogRef.close({event: this.action, data: this.LOCAL_DATA});
            else
            this.openSnackBar("Ya existe un escenario con el nombre: "+this.LOCAL_DATA.nombre,"Cerrar");

        }
      );
      }else{
        this.dialogRef.close({event: this.action, data: this.LOCAL_DATA});
      }
      
  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

  remove(probabilidad: any): void {
    var index = -1;

    for(var i=0; this.dataSource.length>i;i++){
      if((probabilidad.id!=null &&  this.dataSource[i].id !=null &&
            probabilidad.nombre== this.dataSource[i].nombre) ||
          (probabilidad.nombre == this.dataSource[i].nombre)){
        index = i;
        break;
      }
    }

    if (index >= 0) {
      this.dataSource.splice(index, 1);
    }
    this.dataSource = [...this.dataSource];
    this.calcularResultados();
  }

  removeI(impacto: any): void {
    var index = -1;

    for(var i=0; this.dataSourceI.length>i;i++){
      if((impacto.id!=null &&  this.dataSourceI[i].id !=null &&
            impacto.nombre== this.dataSourceI[i].nombre) ||
          (impacto.nombre == this.dataSourceI[i].nombre)){
        index = i;
        break;
      }
    }

    if (index >= 0) {
      this.dataSourceI.splice(index, 1);
    }

    this.dataSourceI = [...this.dataSourceI];
    this.calcularResultados();
  }

  addLine():void{

    if(this.dataSource == undefined){
      this.dataSource = [];
    }

    if (this.new_line_p.new) {
      this.dataSource.push(this.new_line_p);
    }

    this.dataSource.sort((a, b) => (a.valor < b.valor) ? 1 : -1);

    this.dataSource = [...this.dataSource];

    this.new_line_p = {id:null,descripcion:'',nombre:'',valor:0,new:true};
    this.calcularResultados();
  }

  addLineI():void{

    if(this.dataSourceI == undefined){
      this.dataSourceI = [];
    }

    if (this.new_line_i.new) {
      this.dataSourceI.push(this.new_line_i);
    }

    this.dataSourceI.sort((a, b) => (a.valor < b.valor) ? 1 : -1);
    this.dataSourceI = [...this.dataSourceI];
    this.new_line_i = {id:null,descripcion:'',nombre:'',valor:0,new:true};
    this.calcularResultados();
  }

  edit(probabilidad: any):void{
    // Add our fruit
    this.new_line_p = probabilidad;
    this.new_line_p.new = false;
    //{id:probabilidad.id,descripcion:probabilidad.descripcion,nombre:probabilidad.nombre,valor:probabilidad.valor};
    //this.calcularResultados();
  }

  editI(impacto: any):void{
    // Add our fruit
    this.new_line_i = impacto;
    this.new_line_i.new = false;
    //{id:impacto.id,descripcion:impacto.descripcion,nombre:impacto.nombre,valor:impacto.valor};
    //this.calcularResultados();
  }

  formulaModificada(){

    this.LOCAL_DATA.apetito=null;
    this.LOCAL_DATA.tolerancia=null;

  }

  calcularResultados(){
      this.dataSourceR = [];
      this.multi = [];

      this.dataSourceI.sort((a, b) => (a.valor > b.valor) ? 1 : -1);
      this.dataSourceI = [...this.dataSourceI];
      this.dataSource.sort((a, b) => (a.valor > b.valor) ? 1 : -1);
      this.dataSource = [...this.dataSource];
      this.customColors = [];

      if(this.LOCAL_DATA.formulaDeExposicion!=null){

        for(var i=0; this.dataSource.length>i;i++){

            var chartV ={"name": this.dataSource[i].nombre +" ("+this.dataSource[i].valor+")",
                          "series": []
                          };

          for(var z=0; this.dataSourceI.length>z;z++){
            const parser = new Parser();
            //let expr = parser.parse('2 * x + 1');
            //console.log(expr.evaluate({ x: 3 })); // 7
            var expression = parser.parse(this.LOCAL_DATA.formulaDeExposicion);
            var result = expression.evaluate({ P: this.dataSource[i].valor, I:this.dataSourceI[z].valor });
            this.dataSourceR.push({probabilidad:this.dataSource[i], impacto:this.dataSourceI[z],resultado:result});
            var nombre_evaluacion = (this.dataSourceI[z].nombre!=null && this.dataSourceI[z].nombre.length>30) ? this.dataSourceI[z].nombre.substring(0,30) +"..." : this.dataSourceI[z].nombre;

            result = Number(result.toFixed(2));
            
            chartV["series"].push(
                                  {"name":nombre_evaluacion +" ("+this.dataSourceI[z].valor+")",
                                  "value":result
                                });
            var color = '#34C229';

            if(result>=this.LOCAL_DATA.apetito)
              color =  '#F1F80C';

            if(result>=this.LOCAL_DATA.tolerancia)
              color =  '#E44D25';

            this.customColors.push({"name":nombre_evaluacion +" ("+this.dataSourceI[z].valor+")","value":color});
          }

          this.multi.push(chartV);
        }

        this.customColors = [...this.customColors];
        this.dataSourceR = [...this.dataSourceR];

        var elementosAActualizar = document.querySelectorAll('[ngx-charts-heat-map-cell]');
        console.log("Cantidad de nodos:"+ elementosAActualizar.length);
        for(var i = 0; i< elementosAActualizar.length;i++){

          var nodo = elementosAActualizar[i];

          var colorRecuadro = this.customColors[i].value;
          nodo['children'][0]['children'][0]['attributes']['fill']['nodeValue'] = colorRecuadro;


        }

      }

      this.dataSourceI.sort((a, b) => (a.valor < b.valor) ? 1 : -1);
      this.dataSourceI = [...this.dataSourceI];
      this.dataSource.sort((a, b) => (a.valor < b.valor) ? 1 : -1);
      this.dataSource = [...this.dataSource];

      this.dataSourceR.sort((a, b) => (a.resultado < b.resultado) ? 1 : -1);
      this.dataSourceR = [...this.dataSourceR];
  }

  setApetito(valor){
    this.LOCAL_DATA.apetito = valor.resultado.toFixed(2);
    this.calcularResultados();
  }

  setTolerancia(valor){
    this.LOCAL_DATA.tolerancia = valor.resultado.toFixed(2);
    this.calcularResultados();
  }

  onSelect(data): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }

  ngOnInit(): void {

    //this.reloadChart();
  }


  reloadChart():void{
     console.log("Reloading chart");
     this.calcularResultados();
     /*var start = new Date().getTime();
     var end = start;
     while(end < start + 1500) {
       end = new Date().getTime()
      }
      this.calcularResultados();
    */
    }



}
